import moment from 'moment';

export const getRangeOptions=(allowedMaxDaysRange)=>{
    let rangeOptions = {
        Today: [moment().utcOffset("+05:30"), moment().utcOffset("+05:30")],
        Yesterday: [moment().utcOffset("+05:30").subtract(1, 'days'), moment().utcOffset("+05:30").subtract(1, 'days')],
        Tomorrow: [moment().utcOffset("+05:30").add(1, 'days'), moment().utcOffset("+05:30").add(1, 'days')],
    }
    if(allowedMaxDaysRange >= 7){
        rangeOptions["This week"] = [moment().utcOffset("+05:30").startOf('week').add(1, 'days'),moment().utcOffset("+05:30").endOf('week').add(1, 'days')];
        rangeOptions["Last week"] = [moment().utcOffset("+05:30").startOf('week').subtract(1,'days').startOf('week').add(1, 'days'),moment().utcOffset("+05:30").startOf('week')]
    }
    if(allowedMaxDaysRange >= 31){
        rangeOptions["This Month"] = [moment().utcOffset("+05:30").startOf('month'), moment().utcOffset("+05:30").endOf('month')];
        rangeOptions["Last Month"] = [moment().utcOffset("+05:30").subtract(1, 'months').date(1), moment().utcOffset("+05:30").startOf('month').subtract(1, 'days')];
        rangeOptions["Next Month"] = [moment().utcOffset("+05:30").add(1, 'months').date(1), moment().utcOffset("+05:30").add(1, 'months').endOf('month')];
    }
    if(allowedMaxDaysRange >= 180){
        rangeOptions["Last 6 Months"] = [moment().utcOffset("+05:30").subtract(7, 'months').date(1), moment().utcOffset("+05:30").startOf('month').subtract(1, 'days')]
    }
    if(allowedMaxDaysRange >= 360){
        rangeOptions["Last Year"] = [moment().utcOffset("+05:30").startOf('year').subtract(1, 'days').startOf('year'), moment().utcOffset("+05:30").startOf('year').subtract(1, 'days').endOf('year')];
    }
    return rangeOptions;
}

export const getDefaultPageSize = 50;

export const getPaginationDetails=(pagination,setPage, defPageSize = 50, setPageSize)=>{
    if(pagination){
        return {
            onChange(current, pageSize) {
                setPage(current);
                setPageSize(pageSize)
            },
            defaultPageSize: defPageSize
        }
    }else{
        return false;
    }
}

// function range(start, end) {
//     const result = [];
//     for (let i = start; i < end; i++) {
//       result.push(i);
//     }
//     return result;
// }
// ============================================================
// Sales report deep link — lets other reports open /report/salesreport
// pre-filled and auto-run. Query params:
//   fromDate, toDate  YYYY-MM-DD (required)
//   dateType          'booking' | 'travel' (default travel)
//   agent             repeatable, one per agent name (omit for all agents)
//   status            repeatable, Confirmed-tab Status filter: 'confirmed' | 'partial' | 'cancelled'
// ============================================================
export const SALES_REPORT_PATH = '/report/salesreport';

export const buildSalesReportLink = ({ fromDate, toDate, isBookingDate, agents, statuses }) => {
    const params = new URLSearchParams();
    params.set('fromDate', fromDate);
    params.set('toDate', toDate);
    params.set('dateType', isBookingDate ? 'booking' : 'travel');
    (agents || []).filter(Boolean).forEach((agent) => params.append('agent', agent));
    (statuses || []).filter(Boolean).forEach((status) => params.append('status', status));
    return `${SALES_REPORT_PATH}?${params.toString()}`;
};

export const parseSalesReportLink = (search) => {
    const params = new URLSearchParams(search || '');
    const from = moment(params.get('fromDate'), 'YYYY-MM-DD', true);
    const to = moment(params.get('toDate'), 'YYYY-MM-DD', true);
    if (!from.isValid() || !to.isValid()) return null;
    return {
        dateRange: [from, to],
        isBookingDate: params.get('dateType') === 'booking',
        agents: params.getAll('agent').filter(Boolean),
        statuses: params.getAll('status').filter(Boolean),
    };
};
